import React, {useEffect, useState} from 'react'
import {Form, AutoComplete, Tag, Input} from "antd";
import {getStockInformation} from "../../services/serviceInventory";

const {Option} = AutoComplete

const ProductionStockWarehouse = ({handler, productionItem, stockLabel, stockId, formInstance}) => {
    const [warehouses, setWarehouses] = useState([])

    useEffect(() => {
        getStockInformation(stockId)
            .then(({data}) => {
                const warehouseOptions = data.map(item => {
                    return {
                        value: item.warehouse.id,
                        text: `${item.warehouse.code} - ${item.warehouse.name}`
                    }
                })
                setWarehouses(warehouseOptions)
            })

        if (formInstance) {
            const selectedWarehouseSource = productionItem.warehouse
                ? `${productionItem.warehouse.code} - ${productionItem.warehouse.name}`
                : ''
            formInstance.setFieldsValue({
                [`warehouse-${stockId}`]: selectedWarehouseSource
            })
        }
    }, [stockId, productionItem, formInstance])

    const handleWarehouseChange = (v, {key}) => {
        handler(stockId, key)
    }

    return (
        <React.Fragment>
            <Form.Item
                label={'Depo & Stok'}
            >
                <Input.Group compact>
                    <Form.Item
                        name={`warehouse-${stockId}`}
                        noStyle
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleWarehouseChange}
                            style={{width: '50%', marginRight: '16px'}}
                        >
                            {
                                warehouses.map(item => {
                                    return <Option key={item.value} value={item.text}/>
                                })
                            }
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item noStyle>
                        <Tag color="geekblue">{stockLabel}</Tag>
                    </Form.Item>
                </Input.Group>
            </Form.Item>
        </React.Fragment>
    )
}
export default ProductionStockWarehouse